import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
    UncontrolledDropdown,
    Modal,
    ModalBody,
    Input,
    ModalHeader,
    Row,
    Col,
    Label
} from "reactstrap";
import Select from "react-select";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Action, ThunkDispatch, createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import DtsEmailsInputs from "Components/Common/FormBuilder/DtsEmailsInputs";
import { emailCreateRequest } from "store/emails/action";
import { ApplicationState } from "store";
import DtsCKEditor from "Components/Common/FormBuilder/DtsCKEditor";
import { subagentGetRequest, clearSubagent } from "store/subagents/action";
import makeAnimated from 'react-select/animated';
import { optionsListGetRequest } from "store/auth/action";
import { isJson, replacePlaceholders } from "utils";

const animatedComponents = makeAnimated();

export interface SuggestionOption {
    readonly value: string;
    readonly label: string;
}

interface FProps {
    emailModals: boolean;
    setEmailModals: (event: boolean) => void;
    record: any;
    model: any;
    to: any;
    setTriggerApi: any,
    studentId: any,
    applicationId: any,
    t: any,
    parentModel: string
}

const EmailModal: React.FC<FProps> = ({
    emailModals,
    setEmailModals,
    to,
    setTriggerApi,
    studentId,
    applicationId,
    record,
    model,
    t,
    parentModel
}) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const userProfile: any = useSelector((state: ApplicationState) => state.auth.userProfile);
    const details: any = useSelector((state: ApplicationState) => state.subagents.details);
    const optionsObj = useSelector((state: ApplicationState) => state.auth.optionData);
    const optionsLoading = useSelector((state: ApplicationState) => state.auth.optionsLoading);
    const layoutModeType = useSelector((state: ApplicationState) => state.layout.layoutModeType);
    const subAgentId = applicationId ? record?.valuesJson?.student?.subagent : record?.valuesJson?.subagent?.id;
    const [isccOn, setisccOn] = useState(false)
    const [isBccOn, setisBccOn] = useState(false)
    const [disabled, setdisabled] = useState(true)
    const [options, setOptions] = useState<any>([]);
    const [emailTemplate, setEmailTemplate] = useState<any>(null);
    const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(null);
    const [emailData, setEmailData] = useState<any>({
        student: studentId,
        application: applicationId,
        to: null
    })


    const customStyles = {
        input: (provided: any) => ({
            ...provided,
            color: layoutModeType === 'light' ? 'black' : 'white',
        }),
        control: (provided: any) => ({
            ...provided,
            backgroundColor: 'transparent'
        }),
        menu: (provided: any) => ({
            ...provided,
            backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
            color: layoutModeType === 'light' ? 'black' : 'white',
            zIndex: 9999
        }),
        option: (provided: any) => ({
            ...provided,
            backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
            color: layoutModeType === 'light' ? 'black' : 'white',
            '&:hover': {
                backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
            },
        }),
    };

    // also clear when unmounting
    useEffect(() => {
        return () => {
            dispatch(clearSubagent());
        };
    }, []);

useEffect(() => {
    if (optionsObj && Array.isArray(optionsObj['templates'])) {

        const newOptions = optionsObj['templates']
            .map((option: any) => {
                const optionsJson = option.valuesJson && isJson(option.valuesJson)
                    ? JSON.parse(option.valuesJson)
                    : option.valuesJson;

                return {
                    label: optionsJson?.name,
                    value: option.id,
                    valuesJson: optionsJson,
                    type: optionsJson?.type, // e.g., "email" or "whatsapp"
                    in_forms: true,
                };
            })
            .filter((opt) => opt.type !== "whatsapp"); // 👈 Adjust the type filter as needed
        setOptions(newOptions);
    }
}, [optionsObj?.['templates']]);


    const toggle = () => {
        if (emailModals) {
            setEmailModals(false);
        } else {
            setEmailModals(true);
        }
    };

    useEffect(() => {
        if (subAgentId) {
            dispatch(subagentGetRequest(subAgentId));
        }
    }, [subAgentId])

    const onSend = () => {
        setdisabled(true)
        const data = { ...emailData, parent: "", from: userProfile?.id, to: emailData?.to ? emailData?.to : to }
        const handleSuccess = () => {
            setEmailModals && setEmailModals(false);
            setTriggerApi && setTriggerApi((triggerApi: boolean) => !triggerApi)
            setdisabled(false)

        }
        const handleFailure = () => { }
        dispatch(emailCreateRequest(data, handleSuccess, handleFailure,parentModel))
    }

    useEffect(() => {
        if (isBccOn) {
            const getID = document.getElementById('BccRecipientsCollapse') as HTMLElement
            if (getID) getID.classList.add("show");
        }
        else {
            const getID = document.getElementById('BccRecipientsCollapse') as HTMLElement
            if (getID) getID.classList.remove("show");
        }
        if (isccOn) {
            const getID = document.getElementById('CcRecipientsCollapse') as HTMLElement
            if (getID) getID.classList.add("show");
        }
        else {
            const getID = document.getElementById('CcRecipientsCollapse') as HTMLElement
            if (getID) getID.classList.remove("show");
        }
    }, [isBccOn, isccOn])

    const onFocus = () => {
        setOptions([]);
        const filter = {
            "filters": [
                { "quick": [], "advance": [], "search": null }
            ],
            "sorts": [
                { "field": "name", "order": "asc" }
            ]
        };
        let filterObject = null;
        dispatch(optionsListGetRequest('templates', filter, 0, 20, filterObject));
    };

    const onInputChange = (value: any) => {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        const newTimeout = setTimeout(() => {
            const filter = {
                "filters": [
                    { "search": { "term": value, "field": "all" } }
                ],
                "sorts": [
                    { "field": "name", "order": "asc" }
                ]
            };
            let filterObject = null;
            dispatch(optionsListGetRequest('templates', filter, 0, 20, filterObject));
        }, 2000);
        setTypingTimeout(newTimeout);
    };

        const onSelectTemplate = (template: any) => {
            const rawBody = template?.valuesJson?.template || "";
            const rawSubject = template?.valuesJson?.subject || "";
    
            const filledBody = replacePlaceholders(rawBody, templateContext);
            const filledSubject = replacePlaceholders(rawSubject, templateContext);

            setEmailTemplate(template);
            setEmailData({ ...emailData, body: filledBody, subject: filledSubject })
        };
const templateContext = model === "students"
        ? {
              students: record?.valuesJson,
              student: record?.valuesJson
          }
        : {
              student:record?.valuesJson?.student,
              students:record?.valuesJson?.student,
              applications:record?.valuesJson,
              application:record?.valuesJson,
          };

    return (
        <React.Fragment>
            <Modal backdrop="static" id="composemodal" className="modal-lg" isOpen={emailModals} toggle={toggle} centered>
                <ModalHeader className="p-3 bg-light" toggle={() => { setEmailModals(false); }}>
                    {t("student.details.activities.new_message")}
                </ModalHeader>
                <ModalBody>
                    <div>
                        <div className="mb-3 position-relative">
                            <Row className="hstack mb-3 position-relative">
                                <Col md={10} lg={10} className="pe-0">
                                    {details?.id ? <DtsEmailsInputs placeholder={"To"} hideCross={true} defaultValue={details?.valuesJson?.email} disabled={!subAgentId} setdisabled={setdisabled} onChange={(values: any) => setEmailData({ ...emailData, to: values })} /> : <DtsEmailsInputs placeholder={"To"} hideCross={true} defaultValue={[`${to}`]} disabled={!subAgentId} setdisabled={setdisabled} onChange={(values: any) => setEmailData({ ...emailData, to: values })} />}
                                </Col>
                                <Col md={2} lg={2} className="ps-0 hstack justify-content-end">
                                    <div className="d-flex">
                                        <button
                                            className="btn btn-link text-reset fw-semibold px-2"
                                            type="button"
                                            onClick={() => setisccOn(!isccOn)}
                                        >
                                            Cc
                                        </button>
                                        <button
                                            className="btn btn-link text-reset fw-semibold px-2"
                                            type="button"
                                            onClick={() => setisBccOn(!isBccOn)}
                                        >
                                            Bcc
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {
                            isccOn ?
                                <div className="collapse" id="CcRecipientsCollapse">
                                    <div className="mb-3">
                                        <label>Cc:</label>
                                        <DtsEmailsInputs placeholder={"Cc"} setdisabled={setdisabled} onChange={(values: any) => setEmailData({ ...emailData, cc: values })} />
                                    </div>
                                </div> :
                                null}
                        {
                            isBccOn ? <div className="collapse" id="BccRecipientsCollapse">
                                <div className="mb-3">
                                    <label>Bcc:</label>
                                    <DtsEmailsInputs placeholder={"Bcc"} setdisabled={setdisabled} onChange={(values: any) => setEmailData({ ...emailData, bcc: values })} />
                                </div>
                            </div>
                                : null
                        }
                        <div className="mb-3">
                            <Input type="text" value={emailData.subject || ""} className="form-control" placeholder={t("student.details.activities.subject")} onChange={(e: any) => setEmailData({ ...emailData, subject: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <Select
                                placeholder="Select template..."
                                onFocus={onFocus}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                isClearable
                                isSearchable
                                styles={customStyles}
                                onInputChange={(inputValue: any) => onInputChange(inputValue)}
                                name="values"
                                onChange={onSelectTemplate}
                                value={emailTemplate}
                                isLoading={optionsLoading}
                                options={optionsLoading ? [{ label: 'Loading...', value: null }] : options || []}
                            />
                        </div>
                        <div>
                            <DtsCKEditor
                                value={emailData.body ? emailData.body : ""}
                                onChange={(data: any) => {
                                    setEmailData((prev: any) => ({ ...prev, body: data }));
                                }}
                                name={'body'}
                                type={'texteditor'}
                                actionButtons={false}
                                defaultValue={emailData.body}
                            />
                        </div>
                    </div>
                    {details?.id ? details?.valuesJson?.allow_student_communication ? <div><span className="text-success small mark">Note: This subagent has allowed student commnunication.</span></div> : <div><span className="small text-danger mark">Note: This subagent has not allowed student commnunication.</span></div> : null}
                </ModalBody>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-ghost-danger"
                        onClick={() => {
                            setEmailModals(false);
                        }}
                    >
                        {t("common.action_button.discard")}
                    </button>

                    <UncontrolledDropdown className="btn-group">
                        <button
                            type="button"
                            className="btn btn-success"
                            disabled={disabled || !emailData.subject || !emailData.body}
                            onClick={() => {
                                onSend();
                            }}
                        >
                            {t("common.action_button.send")}
                        </button>
                    </UncontrolledDropdown>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default withTranslation()(EmailModal);
